import * as React from 'react'

function IconSeparator(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={'100%'}
      height={235}
      viewBox="0 0 1096 235"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1091 0v92.5c0 13.807-11.19 25-25 25H30c-13.807 0-25 11.193-25 25V235v-8"
        stroke="#F4BA27"
        strokeWidth={10}
      />
    </svg>
  )
}

export default IconSeparator
